module.exports = __webpack_public_path__ + "static/media/electronics.3c5e811a.jpg";